import React from 'react';

import AppLoader from '@sharedComponent/loaders/app-loader';
import { LoginRoutes } from '@routes';

const LoadingPresentational = ({ appLoader }) => {
	return <div className="container_app">{appLoader ? <AppLoader /> : <LoginRoutes />}</div>;
};

export default LoadingPresentational;
